<template>
    <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import { Slide, RecycleList } from '@didi/rich-ui'
Vue.use(Slide)
Vue.use(RecycleList)

export default {
  name: 'xtc'
}
</script>
